import { useMemo } from 'react'
import { classNames } from '@app/utils/classes'

export const useIssueFeedStyles = ({
  feedOpen,
  hideSync,
}: {
  feedOpen?: boolean
  hideSync?: boolean
}) => {
  return useMemo(() => {
    const mobileStyles = feedOpen
      ? `h-full w-full z-20 overflow-y-auto`
      : 'max-h-[60px] bottom-0 rounded-top lg:max-h-full lg:overflow-y-auto lg:rounded-none lg:h-full lg:bottom-0 lg:top-0 lg:pl-0 lg:z-20'

    const topStyles = classNames(
      `fixed bottom-0`,
      mobileStyles,
      'gap-x-4 lg:w-[28vw] lg:max-w-[460px]',
      feedOpen ? 'bg-lightgray dark:bg-[rgb(14,14,19)]' : '',
      hideSync
        ? 'bg-lightgray dark:bg-[rgb(14,14,19)]'
        : 'lg:bg-lightgray lg:dark:bg-[rgb(14,14,19)]',
      !feedOpen && !hideSync ? 'w-40 rtl:left-0 ltr:right-0' : 'w-full'
    )

    return {
      mainStyle: classNames(
        feedOpen ? 'z-20' : '',
        `border-t md:border-t-0 fixed lg:w-[28vw] lg:relative lg:max-w-[460px]`
      ),
      topStyles,
    }
  }, [feedOpen, hideSync])
}
